import { render } from "./FormFileUpload.vue?vue&type=template&id=2dc720c2"
import script from "./FormFileUpload.vue?vue&type=script&lang=js"
export * from "./FormFileUpload.vue?vue&type=script&lang=js"

import "./FormFileUpload.vue?vue&type=style&index=0&id=2dc720c2&lang=css"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__